import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import TruckIcon from "@mui/icons-material/LocalShippingOutlined";
import TrackingIcon from "@mui/icons-material/LocationOnOutlined";
// import DriverIcon from "../../../assets/images/driver_icon.png";
import { clearAllLSData } from "../../../funcs/LSFuncs";
import notify from "../../../funcs/ToastFuncs";
import useNetworkRequest from "../../../hooks/NetworkRequest";
import { ENDPOINTS, urlWithPrefix } from "../../../configs/APIConfig";
const DashLayoutCtx = createContext();

function DashLayoutCtxProvider({ children }) {
  const navigate = useNavigate();
  const { fetchData } = useNetworkRequest();
  const abortControllerRef = useRef(null);

  const navWidth = "250px";
  const dashTabs = [
    {
      id: 1,
      label: "Trucks",
      path: "trucks",
      icon: <TruckIcon />,
      visible: true,
    },
    {
      id: 2,
      label: "Live Tracking",
      path: "tracking",
      icon: <TrackingIcon />,
      visible: true,
    },
    // {
    //   id: 2,
    //   label: "Drivers",
    //   path: "drivers",
    //   icon: DriverIcon,
    // },
    {
      id: 4,
      label: "Profile",
      path: "profile",
      icon: <></>,
      visible: false,
    },
  ];
  const navToScreen = (id) => {
    var tab = dashTabs.find((item) => item.id === id);
    if (tab) {
      navigate(`/dashboard/${tab.path}`);
      setsplitView(false);
      setexpandedView(false);
      settransferBin(null);
    }
  };

  const navToErrorScreen = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    navigate("/error", {
      state: {
        releaseProtection: true,
      },
    });
  };

  const [savedTrucks, setsavedTrucks] = useState([]);

  useEffect(() => {
    getSavedList();
    // eslint-disable-next-line
  }, []);

  const isTruckSaved = (regNo) => {
    let truck = savedTrucks.find(
      (item) => item.rc_no === regNo.replace(" ", "")
    );
    return !!truck;
  };

  const saveTruck = async (regNo) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    let payload = {
      vehicle_number: regNo,
    };

    try {
      const resp = await fetchData({
        url: urlWithPrefix(ENDPOINTS.DASHBOARD.TRUCKS.SAVE_TRUCK.url),
        method: ENDPOINTS.DASHBOARD.TRUCKS.SAVE_TRUCK.method,
        authRequired: true,
        timeout: 20000, // 20 Sec timeout
        signal: abortController.signal,
        body: payload,
      });
      if (resp.status === 200) {
        getSavedList();
        notify("Truck " + regNo + " saved.", "success");
      } else {
        throw new Error("Failed to save truck.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getSavedList = async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    try {
      const resp = await fetchData({
        url: urlWithPrefix(ENDPOINTS.DASHBOARD.TRUCKS.GET_SAVED.url),
        method: ENDPOINTS.DASHBOARD.TRUCKS.GET_SAVED.method,
        authRequired: true,
        timeout: 20000, // 20 Sec timeout
        signal: abortController.signal,
      });
      if (resp?.data?.vehicles?.length > 0) {
        setsavedTrucks(resp.data.vehicles);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const logOutFromDashboard = async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    try {
      const resp = await fetchData({
        url: urlWithPrefix(ENDPOINTS.NAV.LOGOUT.url),
        method: ENDPOINTS.NAV.LOGOUT.method,
        authRequired: true,
        timeout: 20000, // 20 Sec timeout
        signal: abortController.signal,
      });
      if (resp.status === 204) {
        clearAllLSData();
        setsplitView(false);
        settransferBin(null);
        navigate(`/login`);
        notify("Logged out", "success", false, 1000);
      } else {
        throw new Error("Failed to log out.");
      }
    } catch (error) {
      console.error("Tracking Details Error", error);
      if (error.code !== "ERR_CANCELED") {
        navToErrorScreen();
      }
    }
  };

  const [selTab, setselTab] = useState(dashTabs[0]);
  const [splitView, setsplitView] = useState(false);
  const [useLSecView, setuseLSecView] = useState(false);
  const [expandedView, setexpandedView] = useState(false);
  const [transferBin, settransferBin] = useState(null);
  const [preloadVehTracking, setpreloadVehTracking] = useState(null);
  return (
    <DashLayoutCtx.Provider
      value={{
        navWidth,
        dashTabs,
        navToScreen,
        selTab,
        setselTab,
        splitView,
        setsplitView,
        transferBin,
        settransferBin,
        logOutFromDashboard,
        preloadVehTracking,
        setpreloadVehTracking,
        savedTrucks,
        setsavedTrucks,
        saveTruck,
        isTruckSaved,
        expandedView,
        setexpandedView,
        useLSecView,
        setuseLSecView,
      }}
    >
      {children}
    </DashLayoutCtx.Provider>
  );
}

const useDashLayoutCtx = () => {
  return useContext(DashLayoutCtx);
};

export { DashLayoutCtxProvider, useDashLayoutCtx };
